export const SHIPPING_COST = 5.99;
export const TAX_ON_ORDER = 1.01;
export const US_STATES = [
  {
    code: '',
    name: 'State',
  },
  {
    code: 'AA',
    name: 'AA Military',
  },
  {
    code: 'AE',
    name: 'AE Military',
  },
  {
    code: 'AK',
    name: 'Alaska',
  },
  {
    code: 'AL',
    name: 'Alabama',
  },
  {
    code: 'AP',
    name: 'AP Military',
  },
  {
    code: 'AR',
    name: 'Arkansas',
  },
  {
    code: 'AZ',
    name: 'Arizona',
  },
  {
    code: 'CA',
    name: 'California',
  },
  {
    code: 'CO',
    name: 'Colorado',
  },
  {
    code: 'CT',
    name: 'Connecticut',
  },
  {
    code: 'DC',
    name: 'D.C.',
  },
  {
    code: 'DE',
    name: 'Delaware',
  },
  {
    code: 'FL',
    name: 'Florida',
  },
  {
    code: 'GA',
    name: 'Georgia',
  },
  {
    code: 'HI',
    name: 'Hawaii',
  },
  {
    code: 'IA',
    name: 'Iowa',
  },
  {
    code: 'ID',
    name: 'Idaho',
  },
  {
    code: 'IL',
    name: 'Illinois',
  },
  {
    code: 'IN',
    name: 'Indiana',
  },
  {
    code: 'KS',
    name: 'Kansas',
  },
  {
    code: 'KY',
    name: 'Kentucky',
  },
  {
    code: 'LA',
    name: 'Louisiana',
  },
  {
    code: 'MA',
    name: 'Massachusetts',
  },
  {
    code: 'MD',
    name: 'Maryland',
  },
  {
    code: 'ME',
    name: 'Maine',
  },
  {
    code: 'MI',
    name: 'Michigan',
  },
  {
    code: 'MN',
    name: 'Minnesota',
  },
  {
    code: 'MO',
    name: 'Missouri',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    code: 'MS',
    name: 'Mississippi',
  },
  {
    code: 'MT',
    name: 'Montana',
  },
  {
    code: 'NC',
    name: 'North Carolina',
  },
  {
    code: 'ND',
    name: 'North Dakota',
  },
  {
    code: 'NE',
    name: 'Nebraska',
  },
  {
    code: 'NH',
    name: 'New Hampshire',
  },
  {
    code: 'NJ',
    name: 'New Jersey',
  },
  {
    code: 'NM',
    name: 'New Mexico',
  },
  {
    code: 'NV',
    name: 'Nevada',
  },
  {
    code: 'NY',
    name: 'New York',
  },
  {
    code: 'OH',
    name: 'Ohio',
  },
  {
    code: 'OK',
    name: 'Oklahoma',
  },
  {
    code: 'OR',
    name: 'Oregon',
  },
  {
    code: 'PA',
    name: 'Pennsylvania',
  },
  {
    code: 'RI',
    name: 'Rhode Island',
  },
  {
    code: 'SC',
    name: 'South Carolina',
  },
  {
    code: 'SD',
    name: 'South Dakota',
  },
  {
    code: 'TN',
    name: 'Tennessee',
  },
  {
    code: 'TX',
    name: 'Texas',
  },
  {
    code: 'US',
    name: 'US',
  },
  {
    code: 'UT',
    name: 'Utah',
  },
  {
    code: 'VA',
    name: 'Virginia',
  },
  {
    code: 'VT',
    name: 'Vermont',
  },
  {
    code: 'WA',
    name: 'Washington',
  },
  {
    code: 'WI',
    name: 'Wisconsin',
  },
  {
    code: 'WV',
    name: 'West Virginia',
  },
  {
    code: 'WY',
    name: 'Wyoming',
  },
];

export const MONTHS_IN_A_YEAR = [
  {
    key: 1,
    value: '1 - January',
  },
  {
    key: 2,
    value: '2 - February',
  },
  {
    key: 3,
    value: '3 - March',
  },
  {
    key: 4,
    value: '4 - April',
  },
  {
    key: 5,
    value: '5 - May',
  },
  {
    key: 6,
    value: '6 - June',
  },
  {
    key: 7,
    value: '7 - July',
  },
  {
    key: 8,
    value: '8 - August',
  },
  {
    key: 9,
    value: '9 - September',
  },
  {
    key: 10,
    value: '10 - October',
  },
  {
    key: 11,
    value: '11 - November',
  },
  {
    key: 12,
    value: '12 - December',
  },
];

export const HYPER_WALLET_TYPE_FOR_EZSHIP = 5;

export const ADDRESS_UPDATION_WAIT_TIME = 40000;

export const BEST_SELLER_CATEGORY_ID = 2289;
export const SHOPPING_ADD_ON_CATEGORY = 2161;
export const COUPON_ADMINS = ['1'];
export const categoriesEligibleForFilters = ['980', '983', '1046', '629', '631', '632'];
export const BACKOFFICE_ONLY_CATEGORIES = ['557', '558'];

export const ACCOUNT_SETTINGS_TABS = [
  'settings',
  'addresses',
  'paymentmethods',
  'paw-points',
  'avatar',
  'earnings-account',
  'notifications',
  'privacypreference',
];

export const RECOMMENDED_ITEMS_KEY = 'petProfilesRecommendedItems';
export const PETPROFILE_KEY = 'petProfile';

export const GM_PRODUCT_QUERY_IDENTIFIER = 'itemCode';
export const GM_NESTED_PRODUCT_QUERY_IDENTIFIER = 'innerItemCode';

export const NEXT_CACHE_REVALIDATE_TIME = 60;
export const HYPER_WALLET_ACCOUNT_TYPE = 6;

export const PUPTIMUS_PRIMIE_CUSTOMER_ID = 1;

export const BUILD_YOUR_PACK_ID = '2840';
export const BASIC_ENROLLMENT_PACK = { ID: '2805', NAME: 'Basic Start Kit' };
export const ZERO_DOLLAR_ENROLLMENT_PACK_IDS = ['2805', '2800', '2880'];

export const NON_PRODUCT_ITEMS = ['coupon', 'PcShipDisc', 'fee', 'USCOFEE'];
export const EZ_SHIP_FREQUENCY = [
  { key: 'Days', value: '12' },
  { key: 'Weekly', value: '1' },
  { key: 'Biweekly', value: '2' },
  { key: 'Monthly', value: '3' },
  { key: 'Quarterly', value: '4' },
  { key: 'Bimonthly', value: '7' },
  { key: 'Every 4 Weeks', value: '8' },
  { key: 'Every 6 Weeks', value: '9' },
  { key: 'Every 8 Weeks', value: '10' },
  { key: 'Every 12 Weeks', value: '11' },
];

export const generateYearsArray = (yearsCount: number, direction: 'past' | 'future' | 'both' = 'future'): number[] => {
  const currentYear = new Date().getFullYear() - 18;
  const years: number[] = [];

  if (direction === 'past' || direction === 'both') {
    for (let i = 0; i <= yearsCount; i++) {
      years.unshift(currentYear - i);
    }
  }

  if (direction === 'future' || direction === 'both') {
    for (let i = 0; i < yearsCount; i++) {
      years.push(currentYear + i);
    }
  }

  return years;
};

export const getDaysInMonth = (month: number, year: number = new Date().getFullYear()) => {
  const daysCount = new Date(year, month, 0).getDate();

  return Array.from({ length: daysCount }, (_, index) => ({
    value: index + 1,
    name: (index + 1).toString(),
  }));
};

export const ALGOLIA_CONFIDENCE_THRESHOLD = 40;
export const REMEMBER_ME_SESSION_TRACKING_KEY = 'pt_remember_me_session';
export const REMEMBER_ME_SESSION_TRACKING_DAYS = 1;
export const REMEMBER_ME_SESSION_IDLE_DURATION_HOURS = 2;
